import React from "react";
import PropTypes from "prop-types";
import { Close } from "./Icons";

var CloseButton = function CloseButton(_ref) {
  var closeHandler = _ref.closeHandler;
  return React.createElement("button", {
    className: "button recorder__close",
    onClick: closeHandler
  }, React.createElement("div", null, React.createElement(Close, null), "Close"));
};

CloseButton.propTypes = process.env.NODE_ENV !== "production" ? {
  closeHandler: PropTypes.func.isRequired
} : {};
export default CloseButton;